module.exports = __webpack_public_path__ + "static/img/active.3ab22244.png";